export default {
  // 暂存用户信息
  setUserAllInfo (state, userAllInfo) {
    state.userAllInfo = userAllInfo;
  },
  // 储存字典表
  setDictTree(state, dicttree) {
    state.dictTree = dicttree;
  },
  // 产品购物车,添加产品
  setShoppingCart(state, preload) {
    state.shoppingCart.push(preload);
  },
  setPayList(state, preload) {
    state.payList = preload;
  },
  // 产品购物车， 修改产品
  changeShoppingCart(state, preload) {
    state.shoppingCart = preload;
  },
  setInvoiceList(state, preload) {
    state.invoiceList = preload;
  },
  setInvoiceMoney(state, preload) {
    state.invoiceMoney = preload;
  },
  setInvoiceRecord(state, preload) {
    state.invoiceRecord = preload;
  },
  setCurrentOrder(state, preload) {
    state.currentOrder = preload;
  },
  setCurrentStore(state, preload) {
    state.currentStore = preload;
  },
  setSelectProduct(state, preload) {
    state.selectProduct = preload;
  }
}

